const preLoader = document.querySelector('.preloader');
preLoader.classList.toggle('fade-out');

const botonX = document.querySelector('.botonesNav .icono');
const botonZ = document.querySelector('.menuParaHab .titulo-loader');
botonX.addEventListener('click', function() {
    const verMenu = document.querySelector('div.menuParaHab');
    verMenu.classList.toggle('fade-out');
});
botonZ.addEventListener('click', function() {
    const verMenu = document.querySelector('div.menuParaHab');
    verMenu.classList.toggle('fade-out');
});

const btnPublicarBitacora = document.querySelector('.publicar-bitacora');
const mensaje = document.getElementById('mensaje');
const fileInput = document.getElementById('foto');
fileInput.addEventListener('change', handleFiles);
btnPublicarBitacora.addEventListener('click', enviarPost);

function handleFiles(f) {
    preview.innerHTML = '';
    const files = fileInput.files
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var imageType = /image.*/;

        if (!file.type.match(imageType)) {
        continue;
        }

        var img = document.createElement("img");
        img.classList.add("obj");
        img.file = file;
        preview.appendChild(img);

        var reader = new FileReader();
        reader.onload = (function(aImg) { return function(e) { aImg.src = e.target.result; }; })(img);
        reader.readAsDataURL(file);
    }
}
async function enviarPost(e) {
    e.preventDefault();
    preLoader.classList.toggle('fade-out');
    
    if (fileInput.files.length === 0){
        const payload = {
            action: 'publicarComentario',
            autor: document.querySelector('#autorMensaje').value,
            comentario: document.getElementById('textoBitacora').value,
            empresa: document.querySelector('#empresaAutor').value,
            cargo: document.querySelector('#cargoAutor').value
         };
        const WEB_APP_URL = "https://script.google.com/macros/s/AKfycbxGnYasniJXpAFlvld89mmaLTtfkTI6CwYZaqv2Y1Skwr3B3XJ9qIywQI03IawcJ4Oruw/exec";
        try {
            const response = await fetch(WEB_APP_URL, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            const resultado = await response.json();
            window.location.replace("/");
        }catch (error) {
                mensaje.innerText = "❌ Error en la petición.";
                console.error(error);
                preLoader.classList.toggle('fade-out');
        }
    }else {

        
        const file = fileInput.files[0];
        
        mensaje.innerText = "Subiendo...";
        
        // Leer archivo y convertir a Base64
        const reader = new FileReader();
        reader.onload = async function(e) {
            const base64String = e.target.result.split(',')[1]; // Quitar el encabezado data:image/...
            
            const payload = {
                base64: base64String,
                fileName: file.name,
                mimeType: file.type,
                action: 'publicarComentarioImagen',
                autor: document.querySelector('#autorMensaje').value,
                comentario: document.getElementById('textoBitacora').value,
                empresa: document.querySelector('#empresaAutor').value,
                cargo: document.querySelector('#cargoAutor').value
            };
            // URL de tu Web App (la obtienes al implementar)
            const WEB_APP_URL = "https://script.google.com/macros/s/AKfycbxGnYasniJXpAFlvld89mmaLTtfkTI6CwYZaqv2Y1Skwr3B3XJ9qIywQI03IawcJ4Oruw/exec";
            try {
                const response = await fetch(WEB_APP_URL, {
                    method: 'POST',
                    body: JSON.stringify(payload)
                });
                const resultado = await response.json();
                if(resultado){
                    window.location.replace("/");
                    // Nota: Con 'no-cors' no podemos leer la respuesta JSON directamente 
                    // por seguridad del navegador, pero el archivo se guardará en Drive.
                    mensaje.innerText = "✅ Proceso completado (revisa tu Drive)";
                }
            } catch (error) {
                mensaje.innerText = "❌ Error en la petición.";
                console.error(error);
                preLoader.classList.toggle('fade-out');
            }
        };
        reader.readAsDataURL(file);
    }
}

const textareaMensaje = document.getElementById('textoBitacora');
const parrafoContador = document.getElementById('contador');
const limite = 500; // El mismo de nuestro atributo maxlength

textareaMensaje.addEventListener('input', function() {
    // 1. Obtenemos cuántos caracteres lleva
    const longitudActual = this.value.length;
    
    // 2. Actualizamos el texto en pantalla
    parrafoContador.textContent = `${longitudActual} / ${limite} caracteres`;
    
    // 3. (Opcional) Cambiar a color rojo si está cerca del límite
    if (longitudActual >= 490) {
        parrafoContador.style.color = 'red';
    } else {
        parrafoContador.style.color = '#666';
    }
     // 4. Reseteamos la altura a 'auto' para que pueda encogerse si el usuario borra texto
    this.style.height = 'auto';
    
    // 5. Ajustamos la altura basándonos en el "scrollHeight" (la altura total del contenido)
    this.style.height = (this.scrollHeight) + 'px';
});
